import { Expose } from 'class-transformer';
import { BaseEntity } from './base.entity';

export class BaseDeleteResponse extends BaseEntity {
  @Expose()
  public deleted: number;
}
